/* Grouped top-navigation for the dashboard.
 * Extracted from DashboardPage.js (Iteration 83 refactor).
 * No behaviour change — moves TAB_GROUPS config + GroupedTabs component into its own file. */
import React from 'react';

export const TAB_GROUPS = [
  {
    id: 'plan',
    label: 'Kalender',
    emoji: '📅',
    color: 'bg-gradient-to-br from-[#E8F0FF] via-[#F5EEFF] to-[#FFE8F5]',
    tabs: [
      { id: 'dagblad',     label: 'Elsas Dagblad', emoji: '📰' },
      { id: 'mysida',      label: 'Min Sida',   emoji: '🌸' },
      { id: 'challenges',  label: 'Utmaningar', emoji: '🏆' },
      { id: 'photo-alarm', label: 'Foto-alarm', emoji: '📸' },
    ],
  },
  {
    id: 'tools',
    label: 'Verktyg',
    emoji: '🛠️',
    color: 'bg-gradient-to-br from-[#FFF5D1] via-[#FFE5B4] to-[#FFC8DD]',
    tabs: [
      { id: 'habits',      label: 'Vanor',      emoji: '🎯' },
      { id: 'focus',       label: 'Fokusera',   emoji: '⏱️' },
      { id: 'notes',       label: 'Notes',      emoji: '🗒️' },
      { id: 'reader',      label: 'Läs upp',    emoji: '🔊' },
      { id: 'voice',       label: 'Spela in',   emoji: '🎙️' },
      { id: 'stats',       label: 'Stats',      emoji: '📊' },
      { id: 'family-play', label: 'Lek-labb',   emoji: '🌧' },
    ],
  },
  {
    id: 'cleaning',
    label: 'Städ',
    emoji: '🧹',
    color: 'bg-[#B9FBC0]',
    tabs: [
      { id: 'rooms',       label: 'Mitt Rum',         emoji: '🏠' },
      { id: 'kickstart',   label: 'Var börjar jag?',  emoji: '📸' },
      { id: 'room-rotation', label: 'Städ-rutan',     emoji: '🗓️' },
      { id: 'farmor-corgi', label: 'Farmor Corgi',   emoji: '🐶' },
      { id: 'redesign',    label: 'Redesign',         emoji: '🌿' },
      { id: 'skincare',    label: 'Hudrutin',         emoji: '🧴' },
      { id: 'konmari',     label: 'Sortera (KonMari)', emoji: '✨' },
      { id: 'inspiration', label: 'Inspiration',      emoji: '📌' },
      { id: 'lost-items',  label: 'Mina prylar',      emoji: '🔍' },
    ],
  },
  {
    id: 'body',
    label: 'Kropp',
    emoji: '💪',
    color: 'bg-gradient-to-br from-[#FFC8DD] to-[#A2D2FF]',
    tabs: [
      { id: 'body',     label: 'Träning',     emoji: '🏃' },
      { id: 'body-hub', label: 'Kropps-hub',  emoji: '🌸' },
      { id: 'style',    label: 'Stil',        emoji: '👗' },
      { id: 'wardrobe', label: 'Garderob',    emoji: '🧥' },
      { id: 'makeup',   label: 'Sminkspegel', emoji: '💄' },
    ],
  },
  {
    id: 'health',
    label: 'Hälsa',
    emoji: '🌿',
    color: 'bg-[#E0F4E1]',
    tabs: [
      { id: 'diary',     label: 'Kära dagbok', emoji: '💗' },
      { id: 'reset-lab', label: 'Reset',       emoji: '🌊' },
      { id: 'fasting',   label: 'Fasta',       emoji: '🔥' },
      { id: 'hypnos',    label: 'Hypnos',      emoji: '🌙' },
      { id: 'vitmagi',   label: 'Vit magi',    emoji: '✨' },
      { id: 'social',    label: 'Möten',       emoji: '🌸' },
      { id: 'influence', label: 'Påverka',     emoji: '✨' },
    ],
  },
  {
    id: 'dreams',
    label: 'Drömmar',
    emoji: '🌟',
    color: 'bg-[#C8B6FF]',
    tabs: [
      { id: 'dreams',     label: 'Mål & Drömmar', emoji: '🎯' },
      { id: 'bucket',     label: 'Bucket List',   emoji: '🪣' },
      { id: 'studio',     label: 'Studio',        emoji: '🎨' },
      { id: 'paint',      label: 'Måla',          emoji: '🖌️' },
      { id: 'pyssel',     label: 'Pyssel',        emoji: '🧶' },
      { id: 'trolla',     label: 'Trolla-verkstan', emoji: '🎩' },
      { id: 'minnes',     label: 'Minnesträning', emoji: '🧠' },
      { id: 'puzzles',    label: 'Tankenötter',   emoji: '🧩' },
      { id: 'pt',         label: 'PT',            emoji: '💪' },
      { id: 'run-coach',  label: 'Löparcoach',    emoji: '🏃‍♀️' },
      { id: 'pt-goal',    label: 'Målpass',       emoji: '🎯' },
      { id: 'experts',    label: 'Experter',      emoji: '✨' },
      { id: 'memories',   label: 'Minnen',        emoji: '🎞️' },
      { id: 'timetravel', label: 'Tidsfeed',      emoji: '🎬' },
      { id: 'timewalk',   label: 'Episk resa',    emoji: '🕰️' },
      { id: 'secret',     label: 'Secret',        emoji: '🔒' },
    ],
  },
  {
    id: 'history',
    label: 'Historia',
    emoji: '📜',
    color: 'bg-[#CDB4DB]',
    tabs: [
      { id: 'history', label: 'Daglig historia', emoji: '📜' },
      { id: 'reading', label: 'Läslogg',         emoji: '📖' },
      { id: 'writing', label: 'Skrivregler',     emoji: '✍️' },
    ],
  },
  {
    id: 'finance',
    label: 'Ekonomi',
    emoji: '💰',
    color: 'bg-[#FFE8A3]',
    tabs: [
      { id: 'envelopes', label: 'Kuvert-budget',    emoji: '✉️' },
      { id: 'stocks',   label: 'Aktier & Fonder',   emoji: '📈' },
      { id: 'shopping', label: 'Att köpa & Budget', emoji: '🛒' },
      { id: 'projects', label: 'Projekt',           emoji: '🛋️' },
    ],
  },
  {
    id: 'pet',
    label: 'Pet & Shop',
    emoji: '🐹',
    color: 'bg-[#FFC8DD]',
    tabs: [
      { id: 'shop',    label: 'Shop',    emoji: '🛍️' },
      { id: 'gallery', label: 'Gallery', emoji: '🖼️' },
    ],
  },
];

export default function GroupedTabs({ activeTab, setActiveTab, activeGroup, setActiveGroup, onJustToday }) {
  // Auto-derive active group from active tab on render
  const currentGroup = TAB_GROUPS.find((g) => g.tabs.some((t) => t.id === activeTab)) || TAB_GROUPS[0];
  const groupId = currentGroup.id === activeGroup ? activeGroup : currentGroup.id;
  const group = TAB_GROUPS.find((g) => g.id === groupId) || TAB_GROUPS[0];

  return (
    <nav className="mb-5 space-y-2" data-testid="grouped-tabs">
      {/* Row 1: 8 main groups */}
      <div className="flex flex-wrap gap-2" data-testid="tab-groups">
        <button
          onClick={() => setActiveTab('dagblad')}
          className={`neo-btn px-3 py-2 flex items-center gap-1.5 text-sm font-black whitespace-nowrap ${activeTab === 'dagblad' ? 'ring-2 ring-[#6B7246] scale-[1.02]' : ''}`}
          style={{ background: '#F4EEE1', color: '#2B2620', fontFamily: "'Playfair Display', Georgia, serif" }}
          data-testid="menu-dagblad"
        >
          📰 <span>Tidningen</span>
        </button>
        {TAB_GROUPS.map((g) => {
          const isActive = g.id === groupId;
          return (
            <button
              key={g.id}
              onClick={() => {
                setActiveGroup(g.id);
                if (!g.tabs.some((t) => t.id === activeTab)) {
                  setActiveTab(g.tabs[0].id);
                }
              }}
              className={`neo-btn px-3 py-2 flex items-center gap-1.5 text-sm font-bold transition-all whitespace-nowrap ${
                isActive ? `${g.color} ring-2 ring-[#D06892] scale-[1.02]` : 'bg-white opacity-80 hover:opacity-100'
              }`}
              data-testid={`group-${g.id}`}
            >
              <span className="text-base">{g.emoji}</span>
              <span>{g.label}</span>
            </button>
          );
        })}
        <button
          onClick={onJustToday}
          className="neo-btn px-3 py-2 flex items-center gap-1.5 text-sm bg-gradient-to-br from-[#FFE8F0] to-[#E8F0FF] font-bold whitespace-nowrap"
          data-testid="just-today-open"
          title="Gömmer allt utom 3 tasks + nästa event"
        >
          🧘 <span>Idag räcker det</span>
        </button>
      </div>

      {/* Row 2: sub-tabs of active group */}
      {group.tabs.length > 1 && (
        <div className="flex flex-wrap gap-1.5 pl-1 pt-1 border-l-2 border-black/10 ml-1" data-testid={`subtabs-${group.id}`}>
          {group.tabs.map((t) => {
            const isActiveTab = t.id === activeTab;
            return (
              <button
                key={t.id}
                onClick={() => setActiveTab(t.id)}
                className={`px-2.5 py-1 rounded-full text-xs font-bold flex items-center gap-1 transition-all border-2 ${
                  isActiveTab
                    ? 'bg-white border-[#D06892] text-[#D06892] shadow-sm'
                    : 'bg-white/40 border-transparent opacity-70 hover:opacity-100 hover:bg-white'
                }`}
                data-testid={`tab-${t.id}`}
              >
                <span>{t.emoji}</span>
                <span>{t.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </nav>
  );
}
